import React from 'react';

/* eslint-disable react/destructuring-assignment,max-lines,react/display-name, react/require-default-props */

var MultiSelectHeader = function MultiSelectHeader(props) {
  var count = props.children.filter(function (child) {
    return child.props.isSelected;
  }).length;
  return /*#__PURE__*/React.createElement("div", {
    className: "combobox-multi-select-header"
  }, "".concat(count, " selected"));
};

export default MultiSelectHeader;
//# sourceMappingURL=MultiSelectHeader.js.map
